import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  boxApply1qmzdb3dh90hg as boxApply,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { getContextualDescriptor2n1gf3b895yb8 as getContextualDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/ContextAware.mjs';
import {
  CONTEXTUAL_getInstance20l1ap7hne5we as CONTEXTUAL_getInstance,
  ENUM_getInstance25239ht7oag6o as ENUM_getInstance,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance,
  MAP_getInstance3e78m6vf98i66 as MAP_getInstance,
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  Char19o2r8palgjof as Char,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  encodeNotNullMark352dnk5r97tvq as encodeNotNullMark,
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import {
  NamedValueEncoder1lca9edk1lf89 as NamedValueEncoder,
  NamedValueDecoderzk26ztf92xbq as NamedValueDecoder,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Tagged.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer,
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer_0,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import {
  toBooleanStrict2uzbjwx3c24mm as toBooleanStrict,
  split3d3yeauc4rm2n as split,
  indexOf1xbs558u7wr52 as indexOf,
  removePrefix279df90bhrqqg as removePrefix,
  substringBefore3n7kj60w69hju as substringBefore,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  toByte1ihbgyfg5m688 as toByte,
  toShort1i0zdidogv7z as toShort,
  toInt2q8uldh7sc951 as toInt,
  toLongkk4waq8msp1k as toLong,
  toDouble1kn912gjoizjp as toDouble,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { single29ec4rh52687r as single } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  decodeSerializableElement$defaulthisepbk9rprr as decodeSerializableElement$default,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Decoding.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  asSequence2phdjljfh9jhx as asSequence,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  filter184huxd00uyfg as filter,
  mapsbvh18eqox7a as map,
  distinct17vua5ffe1cfv as distinct,
  toListx6x8nvfmvvht as toList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _set_singleElementUri__gttn4x($this, value) {
  if (!($this.encodedStructure_1 == null) || !($this.singleElementUri_1 == null))
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('UriFormat.UriEncoder can only encode a single primitive or structure');
  $this.singleElementUri_1 = value;
}
function _set_encodedStructure__qnp1fy($this, value) {
  if (!($this.singleElementUri_1 == null) || !($this.encodedStructure_1 == null))
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('UriFormat.UriEncoder can only encode a single primitive or structure');
  $this.encodedStructure_1 = value;
}
function encodePrimitive($this, value) {
  _set_singleElementUri__gttn4x($this, encodeURIComponent(toString(value)));
}
function fullTag($this, index) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = $this.prefix_1;
  if (charSequenceLength(this_0) === 0) {
    tmp = '' + index;
  } else {
    tmp = $this.prefix_1 + '.' + index;
  }
  return tmp;
}
function fullTag_0($this, key) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = $this.prefix_1;
  if (charSequenceLength(this_0) === 0) {
    tmp = key;
  } else {
    tmp = $this.prefix_1 + '.' + key;
  }
  return tmp;
}
function _get_decoded__qfhu91($this) {
  return decodeURIComponent($this.uri_1);
}
function fullTag_1($this, tag) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = $this.prefix_1;
  if (charSequenceLength(this_0) === 0) {
    tmp = tag;
  } else {
    tmp = $this.prefix_1 + '.' + tag;
  }
  return tmp;
}
function hasKeyOrPrefix($this, tag) {
  var full = fullTag_1($this, tag);
  var tmp;
  if ($this.map_1.containsKey_aw81wo_k$(full)) {
    tmp = true;
  } else {
    var tmp0 = $this.map_1.get_keys_wop4xp_k$();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (startsWith(element, full + '.')) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
function _get_size__ddoh9m($this) {
  var tmp0 = $this.size$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('size', 1, tmp, UriFormat$ListDecoder$_get_size_$ref_vq9a14(), null);
  return tmp0.get_value_j01efc_k$();
}
function fullTag_2($this, index) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = $this.prefix_1;
  if (charSequenceLength(this_0) === 0) {
    tmp = '' + index;
  } else {
    tmp = $this.prefix_1 + '.' + index;
  }
  return tmp;
}
function hasKeyOrPrefix_0($this, index) {
  var full = fullTag_2($this, index);
  var tmp;
  if ($this.map_1.containsKey_aw81wo_k$(full)) {
    tmp = true;
  } else {
    var tmp0 = $this.map_1.get_keys_wop4xp_k$();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (startsWith(element, full + '.')) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
function UriFormat$ListDecoder$_get_size_$ref_vq9a14() {
  return constructCallableReference((p0) => _get_size__ddoh9m(p0), 1, 0, 74);
}
function _get_keys__d97k5z($this) {
  var tmp0 = $this.keys$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('keys', 1, tmp, UriFormat$MapDecoder$_get_keys_$ref_sqsxkv(), null);
  return tmp0.get_value_j01efc_k$();
}
function fullTag_3($this, key) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = $this.prefix_1;
  if (charSequenceLength(this_0) === 0) {
    tmp = key;
  } else {
    tmp = $this.prefix_1 + '.' + key;
  }
  return tmp;
}
function currentKey($this) {
  var keyIndex = $this.currentIndex_1 / 2 | 0;
  return _get_keys__d97k5z($this).get_c1px32_k$(keyIndex);
}
function UriFormat$MapDecoder$_get_keys_$ref_sqsxkv() {
  return constructCallableReference((p0) => _get_keys__d97k5z(p0), 1, 0, 75);
}
function unwrap($this, $receiver) {
  var $this_0 = $this;
  var $this_1 = $receiver;
  $l$1: do {
    $l$0: do {
      var tmp;
      if (equals($this_1.get_kind_wop7ml_k$(), CONTEXTUAL_getInstance())) {
        var tmp0_safe_receiver = getContextualDescriptor($this_0.serializersModule_1, $this_1);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : unwrap($this_0, tmp0_safe_receiver);
        tmp = tmp1_elvis_lhs == null ? $this_1 : tmp1_elvis_lhs;
      } else if ($this_1.get_isInline_usk17w_k$()) {
        var tmp0 = $this_0;
        var tmp1 = $this_1.getElementDescriptor_ncda77_k$(0);
        $this_0 = tmp0;
        $this_1 = tmp1;
        continue $l$0;
      } else {
        tmp = $this_1;
      }
      return tmp;
    }
     while (false);
  }
   while (true);
}
function isNonStructure($this, $receiver) {
  var tmp;
  if ($receiver instanceof PrimitiveKind()) {
    tmp = true;
  } else {
    tmp = equals($receiver, ENUM_getInstance());
  }
  return tmp;
}
function ensureMapHasEncodableKeys($this, mapDescriptor) {
  // Inline function 'kotlin.require' call
  if (!isNonStructure($this, mapDescriptor.getElementDescriptor_ncda77_k$(0).get_kind_wop7ml_k$())) {
    var message = 'UriFormat only supports maps with primitive and enum-type keys.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
}
function getProperStructureEncoder($this, descriptor, into, prefix) {
  prefix = prefix === VOID ? '' : prefix;
  var descriptor_0 = unwrap($this, descriptor);
  var tmp0_subject = descriptor_0.get_kind_wop7ml_k$();
  var tmp;
  var tmp_0;
  if (equals(tmp0_subject, CLASS_getInstance())) {
    tmp_0 = true;
  } else {
    tmp_0 = tmp0_subject instanceof PolymorphicKind();
  }
  if (tmp_0) {
    tmp = ClassEncoder().new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ClassEncoder_7ef4js_k$($this, prefix, into);
  } else {
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp = ListEncoder().new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ListEncoder_moepb9_k$($this, prefix, into);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        ensureMapHasEncodableKeys($this, descriptor_0);
        tmp = MapEncoder().new_com_lightningkite_kotlinx_serialization_uri_UriFormat_MapEncoder_b14jtt_k$($this, prefix, into);
      } else {
        if (equals(tmp0_subject, OBJECT_getInstance())) {
          tmp = ObjectEncoder().new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ObjectEncoder_44erze_k$($this, prefix, into);
        } else {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Only structure types can be encoded as a string map. Got ' + descriptor_0.get_kind_wop7ml_k$().toString() + ' (' + descriptor_0.get_serialName_u2rqhk_k$() + ').');
        }
      }
    }
  }
  return tmp;
}
function getProperStructureDecoder($this, descriptor, prefix, source) {
  var descriptor_0 = unwrap($this, descriptor);
  var tmp0_subject = descriptor_0.get_kind_wop7ml_k$();
  var tmp;
  var tmp_0;
  if (equals(tmp0_subject, CLASS_getInstance())) {
    tmp_0 = true;
  } else {
    tmp_0 = tmp0_subject instanceof PolymorphicKind();
  }
  if (tmp_0) {
    tmp = new (ClassDecoder())($this, prefix, source);
  } else {
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp = new (ListDecoder())($this, prefix, source);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        ensureMapHasEncodableKeys($this, descriptor_0);
        tmp = new (MapDecoder())($this, prefix, source);
      } else {
        if (equals(tmp0_subject, OBJECT_getInstance())) {
          tmp = new (ObjectDecoder())($this, prefix, source);
        } else {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Only structure types can be encoded as a string map. Got ' + descriptor_0.get_kind_wop7ml_k$().toString() + ' (' + descriptor_0.get_serialName_u2rqhk_k$() + ').');
        }
      }
    }
  }
  return tmp;
}
var UriEncoderClass;
function UriEncoder() {
  if (UriEncoderClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.serializersModule_1 = this.$this_1.serializersModule_1;
        this.singleElementUri_1 = null;
        this.encodedStructure_1 = null;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      getUriOrNull_j1lckg_k$() {
        var tmp0_elvis_lhs = this.singleElementUri_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.encodedStructure_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = this.$this_1.encodeToString_hz9uyy_k$(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      getUri_kntv4a_k$() {
        var tmp0_elvis_lhs = this.getUriOrNull_j1lckg_k$();
        return tmp0_elvis_lhs == null ? 'NULL' : tmp0_elvis_lhs;
      }
      encodeNull_ejiosz_k$() {
      }
      encodeBoolean_tu2e59_k$(value) {
        return encodePrimitive(this, value);
      }
      encodeByte_6txfee_k$(value) {
        return encodePrimitive(this, value);
      }
      encodeShort_gza6si_k$(value) {
        return encodePrimitive(this, value);
      }
      encodeChar_id8ngf_k$(value) {
        return encodePrimitive(this, new (Char())(value));
      }
      encodeInt_y5zi3z_k$(value) {
        return encodePrimitive(this, value);
      }
      encodeLong_vlw3uq_k$(value) {
        return encodePrimitive(this, value);
      }
      encodeFloat_b8b85a_k$(value) {
        return encodePrimitive(this, value);
      }
      encodeDouble_n270q9_k$(value) {
        return encodePrimitive(this, value);
      }
      encodeString_424b5v_k$(value) {
        return encodePrimitive(this, value);
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        _set_singleElementUri__gttn4x(this, encodeURIComponent(enumDescriptor.getElementName_u4sqmf_k$(index)));
      }
      encodeInline_wxp5pu_k$(descriptor) {
        return this;
      }
      beginStructure_yljocp_k$(descriptor) {
        // Inline function 'kotlin.collections.mutableMapOf' call
        var map = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        _set_encodedStructure__qnp1fy(this, map);
        return getProperStructureEncoder(this.$this_1, descriptor, map, '');
      }
    }
    protoOf($).encodeNotNullMark_415a1t_k$ = encodeNotNullMark;
    protoOf($).beginCollection_9edss2_k$ = beginCollection;
    protoOf($).encodeSerializableValue_3uuzip_k$ = encodeSerializableValue;
    initMetadataForClass($, 'UriEncoder', VOID, VOID, [Encoder()]);
    UriEncoderClass = $;
  }
  return UriEncoderClass;
}
var StringMapEncoderClass;
function StringMapEncoder() {
  if (StringMapEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor($outer, prefix, dest) {
        return new.target.new_com_lightningkite_kotlinx_serialization_uri_UriFormat_StringMapEncoder_sp8p1n_k$($outer, prefix, dest);
      }
      static new_com_lightningkite_kotlinx_serialization_uri_UriFormat_StringMapEncoder_sp8p1n_k$($outer, prefix, dest, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$($box);
        $this.prefix_1 = prefix;
        $this.dest_1 = dest;
        $this.serializersModule_1 = $this.$this_1.serializersModule_1;
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      beginStructure_yljocp_k$(descriptor) {
        return getProperStructureEncoder(this.$this_1, descriptor, this.dest_1, this.prefix_1);
      }
    }
    initMetadataForClass($, 'StringMapEncoder');
    StringMapEncoderClass = $;
  }
  return StringMapEncoderClass;
}
var ClassEncoderClass;
function ClassEncoder() {
  if (ClassEncoderClass === VOID) {
    class $ extends NamedValueEncoder() {
      constructor($outer, map) {
        return new.target.new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ClassEncoder_l99v73_k$($outer, map);
      }
      static new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ClassEncoder_l99v73_k$($outer, map, $box) {
        if ($box === VOID)
          $box = {};
        var tmp;
        if (map === VOID) {
          // Inline function 'kotlin.collections.mutableMapOf' call
          tmp = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        } else {
          tmp = map;
        }
        map = tmp;
        $box.$this_1 = $outer;
        var $this = this.new_kotlinx_serialization_internal_NamedValueEncoder_pcvqd2_k$($box);
        $this.map_1 = map;
        $this.serializersModule_1 = $this.$this_1.serializersModule_1;
        return $this;
      }
      static new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ClassEncoder_7ef4js_k$($outer, prefix, map, $box) {
        var $this = this.new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ClassEncoder_l99v73_k$($outer, map, $box);
        $this.pushTag_bibnaf_k$(prefix);
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeSerializableValue_3uuzip_k$(serializer, value) {
        if (serializer instanceof AbstractPolymorphicSerializer()) {
          var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
          var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
          this.encodeTaggedString_w0iev4_k$(this.nested_cwsnxf_k$('type'), actualSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
          return actualSerializer.serialize_5ase3y_k$(this, value);
        }
        return serializer.serialize_5ase3y_k$(this, value);
      }
      encodeTaggedValue_sfcjfh_k$(tag, value) {
        var tmp0 = this.map_1;
        // Inline function 'kotlin.collections.set' call
        var value_0 = encodeURIComponent(toString(value));
        tmp0.put_4fpzoq_k$(tag, value_0);
      }
      encodeTaggedValue_uwjsrc_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      beginStructure_yljocp_k$(descriptor) {
        return getProperStructureEncoder(this.$this_1, descriptor, this.map_1, this.popTag_g8zwqf_k$());
      }
      encodeTaggedNull_qzw0n5_k$(tag) {
      }
      encodeTaggedNull_ef6rw0_k$(tag) {
        return this.encodeTaggedNull_qzw0n5_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      encodeTaggedEnum_56ln9q_k$(tag, enumDescriptor, ordinal) {
        var tmp0 = this.map_1;
        // Inline function 'kotlin.collections.set' call
        var value = encodeURIComponent(enumDescriptor.getElementName_u4sqmf_k$(ordinal));
        tmp0.put_4fpzoq_k$(tag, value);
      }
      encodeTaggedEnum_vfihkh_k$(tag, enumDescriptor, ordinal) {
        return this.encodeTaggedEnum_56ln9q_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor, ordinal);
      }
    }
    initMetadataForClass($, 'ClassEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    ClassEncoderClass = $;
  }
  return ClassEncoderClass;
}
var ListEncoderClass;
function ListEncoder() {
  if (ListEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor($outer, prefix, map) {
        return new.target.new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ListEncoder_moepb9_k$($outer, prefix, map);
      }
      static new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ListEncoder_moepb9_k$($outer, prefix, map, $box) {
        if ($box === VOID)
          $box = {};
        var tmp;
        if (map === VOID) {
          // Inline function 'kotlin.collections.mutableMapOf' call
          tmp = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        } else {
          tmp = map;
        }
        map = tmp;
        $box.$this_1 = $outer;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$($box);
        $this.prefix_1 = prefix;
        $this.map_1 = map;
        $this.serializersModule_1 = $this.$this_1.serializersModule_1;
        $this.currentIndex_1 = 0;
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeNull_ejiosz_k$() {
        var tmp0 = this.map_1;
        var _unary__edvuaz = this.currentIndex_1;
        this.currentIndex_1 = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = fullTag(this, _unary__edvuaz);
        tmp0.put_4fpzoq_k$(key, 'NULL');
      }
      encodeValue_g68i1f_k$(value) {
        var tmp0 = this.map_1;
        var _unary__edvuaz = this.currentIndex_1;
        this.currentIndex_1 = _unary__edvuaz + 1 | 0;
        var tmp2 = fullTag(this, _unary__edvuaz);
        // Inline function 'kotlin.collections.set' call
        var value_0 = encodeURIComponent(toString(value));
        tmp0.put_4fpzoq_k$(tmp2, value_0);
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        return this.encodeValue_g68i1f_k$(enumDescriptor.getElementName_u4sqmf_k$(index));
      }
      beginStructure_yljocp_k$(descriptor) {
        var _unary__edvuaz = this.currentIndex_1;
        this.currentIndex_1 = _unary__edvuaz + 1 | 0;
        return getProperStructureEncoder(this.$this_1, descriptor, this.map_1, fullTag(this, _unary__edvuaz));
      }
      endStructure_1xqz0n_k$(descriptor) {
        if (this.currentIndex_1 === 0) {
          var tmp0 = this.map_1;
          // Inline function 'kotlin.collections.set' call
          var key = this.prefix_1;
          tmp0.put_4fpzoq_k$(key, '~');
        }
      }
    }
    initMetadataForClass($, 'ListEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    ListEncoderClass = $;
  }
  return ListEncoderClass;
}
var MapEncoderClass;
function MapEncoder() {
  if (MapEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor($outer, prefix, map) {
        return new.target.new_com_lightningkite_kotlinx_serialization_uri_UriFormat_MapEncoder_b14jtt_k$($outer, prefix, map);
      }
      static new_com_lightningkite_kotlinx_serialization_uri_UriFormat_MapEncoder_b14jtt_k$($outer, prefix, map, $box) {
        if ($box === VOID)
          $box = {};
        var tmp;
        if (map === VOID) {
          // Inline function 'kotlin.collections.mutableMapOf' call
          tmp = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        } else {
          tmp = map;
        }
        map = tmp;
        $box.$this_1 = $outer;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$($box);
        $this.prefix_1 = prefix;
        $this.map_1 = map;
        $this.serializersModule_1 = $this.$this_1.serializersModule_1;
        $this.currentKey_1 = null;
        $this.entryCount_1 = 0;
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeNull_ejiosz_k$() {
        var key = this.currentKey_1;
        if (!(key == null)) {
          var tmp0 = this.map_1;
          // Inline function 'kotlin.collections.set' call
          var key_0 = fullTag_0(this, key);
          tmp0.put_4fpzoq_k$(key_0, 'NULL');
          this.currentKey_1 = null;
        }
      }
      encodeValue_g68i1f_k$(value) {
        var key = this.currentKey_1;
        if (key == null) {
          this.currentKey_1 = toString(value);
        } else {
          var tmp0 = this.map_1;
          var tmp2 = fullTag_0(this, key);
          // Inline function 'kotlin.collections.set' call
          var value_0 = encodeURIComponent(toString(value));
          tmp0.put_4fpzoq_k$(tmp2, value_0);
          this.currentKey_1 = null;
          this.entryCount_1 = this.entryCount_1 + 1 | 0;
        }
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        return this.encodeValue_g68i1f_k$(enumDescriptor.getElementName_u4sqmf_k$(index));
      }
      beginStructure_yljocp_k$(descriptor) {
        var tmp0_elvis_lhs = this.currentKey_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Map value must have a key');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.currentKey_1 = null;
        this.entryCount_1 = this.entryCount_1 + 1 | 0;
        return getProperStructureEncoder(this.$this_1, descriptor, this.map_1, fullTag_0(this, key));
      }
      endStructure_1xqz0n_k$(descriptor) {
        if (this.entryCount_1 === 0) {
          var tmp0 = this.map_1;
          // Inline function 'kotlin.collections.set' call
          var key = this.prefix_1;
          tmp0.put_4fpzoq_k$(key, '~');
        }
      }
    }
    initMetadataForClass($, 'MapEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    MapEncoderClass = $;
  }
  return MapEncoderClass;
}
var ObjectEncoderClass;
function ObjectEncoder() {
  if (ObjectEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor($outer, prefix, map) {
        return new.target.new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ObjectEncoder_44erze_k$($outer, prefix, map);
      }
      static new_com_lightningkite_kotlinx_serialization_uri_UriFormat_ObjectEncoder_44erze_k$($outer, prefix, map, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$($box);
        $this.prefix_1 = prefix;
        $this.map_1 = map;
        $this.serializersModule_1 = $this.$this_1.serializersModule_1;
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeValue_g68i1f_k$(value) {
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
        // Inline function 'kotlin.text.isNotEmpty' call
        var this_0 = this.prefix_1;
        if (charSequenceLength(this_0) > 0) {
          var tmp0 = this.map_1;
          // Inline function 'kotlin.collections.set' call
          var key = this.prefix_1;
          tmp0.put_4fpzoq_k$(key, '~');
        }
      }
    }
    initMetadataForClass($, 'ObjectEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    ObjectEncoderClass = $;
  }
  return ObjectEncoderClass;
}
var UriDecoderClass;
function UriDecoder() {
  if (UriDecoderClass === VOID) {
    class $ {
      constructor($outer, uri) {
        this.$this_1 = $outer;
        this.uri_1 = uri;
        this.serializersModule_1 = this.$this_1.serializersModule_1;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeNull_jzrmuj_k$() {
        return null;
      }
      decodeNotNullMark_us4ba1_k$() {
        return !(this.uri_1 === 'NULL');
      }
      decodeBoolean_m0aca_k$() {
        return toBooleanStrict(_get_decoded__qfhu91(this));
      }
      decodeByte_jzz7je_k$() {
        return toByte(_get_decoded__qfhu91(this));
      }
      decodeShort_jjqk32_k$() {
        return toShort(_get_decoded__qfhu91(this));
      }
      decodeChar_dcmcfa_k$() {
        return single(_get_decoded__qfhu91(this));
      }
      decodeInt_8iq8f5_k$() {
        return toInt(_get_decoded__qfhu91(this));
      }
      decodeLong_jzt186_k$() {
        return toLong(_get_decoded__qfhu91(this));
      }
      decodeFloat_jcnrwu_k$() {
        // Inline function 'kotlin.text.toFloat' call
        var this_0 = _get_decoded__qfhu91(this);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return toDouble(this_0);
      }
      decodeDouble_ur8l0f_k$() {
        return toDouble(_get_decoded__qfhu91(this));
      }
      decodeString_x3hxsx_k$() {
        return _get_decoded__qfhu91(this);
      }
      decodeEnum_slg6lu_k$(enumDescriptor) {
        return enumDescriptor.getElementIndex_utfbym_k$(_get_decoded__qfhu91(this));
      }
      decodeInline_ux3vza_k$(descriptor) {
        return this;
      }
      beginStructure_yljocp_k$(descriptor) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = split(this.uri_1, charArrayOf([_Char___init__impl__6a9atx(38)]));
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.text.isNotEmpty' call
          if (charSequenceLength(element) > 0) {
            destination.add_utx5q5_k$(element);
          }
        }
        // Inline function 'kotlin.collections.associate' call
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          var index = indexOf(element_0, _Char___init__impl__6a9atx(61));
          // Inline function 'kotlin.collections.plusAssign' call
          var pair = index === -1 ? to(element_0, '') : to(substring(element_0, 0, index), decodeURIComponent(substring_0(element_0, index + 1 | 0)));
          destination_0.put_4fpzoq_k$(pair.first_1, pair.second_1);
        }
        // Inline function 'kotlin.also' call
        println('String Map: ' + toString(destination_0));
        return getProperStructureDecoder(this.$this_1, descriptor, '', destination_0);
      }
    }
    protoOf($).decodeSerializableValue_xpnpad_k$ = decodeSerializableValue;
    initMetadataForClass($, 'UriDecoder', VOID, VOID, [Decoder()]);
    UriDecoderClass = $;
  }
  return UriDecoderClass;
}
var StringMapDecoderClass;
function StringMapDecoder() {
  if (StringMapDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor($outer, source, prefix, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        super($box);
        this.prefix_1 = prefix;
        var tmp = this;
        // Inline function 'kotlin.collections.mapValues' call
        // Inline function 'kotlin.collections.mapValuesTo' call
        var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(source.get_size_woubt6_k$()));
        // Inline function 'kotlin.collections.associateByTo' call
        var _iterator__ex2g4s = source.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp_0 = element.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var value = element.get_value_j01efc_k$();
          var tmp$ret$4 = decodeURIComponent(value);
          destination.put_4fpzoq_k$(tmp_0, tmp$ret$4);
        }
        tmp.source_1 = destination;
        this.serializersModule_1 = this.$this_1.serializersModule_1;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_cv3bvm_k$();
      }
      beginStructure_yljocp_k$(descriptor) {
        return getProperStructureDecoder(this.$this_1, descriptor, this.prefix_1, this.source_1);
      }
    }
    initMetadataForClass($, 'StringMapDecoder');
    StringMapDecoderClass = $;
  }
  return StringMapDecoderClass;
}
var ClassDecoderClass;
function ClassDecoder() {
  if (ClassDecoderClass === VOID) {
    class $ extends NamedValueDecoder() {
      constructor($outer, prefix, map, $box) {
        if ($box === VOID)
          $box = {};
        prefix = prefix === VOID ? '' : prefix;
        $box.$this_1 = $outer;
        super($box);
        this.prefix_1 = prefix;
        this.map_1 = map;
        this.serializersModule_1 = this.$this_1.serializersModule_1;
        this.currentIndex_1 = 0;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        while (this.currentIndex_1 < descriptor.get_elementsCount_288r0x_k$()) {
          var name = descriptor.getElementName_u4sqmf_k$(this.currentIndex_1);
          if (hasKeyOrPrefix(this, name)) {
            var _unary__edvuaz = this.currentIndex_1;
            this.currentIndex_1 = _unary__edvuaz + 1 | 0;
            return _unary__edvuaz;
          }
          this.currentIndex_1 = this.currentIndex_1 + 1 | 0;
        }
        return -1;
      }
      beginStructure_yljocp_k$(descriptor) {
        var tmp0_safe_receiver = this.get_currentTagOrNull_yhyzw_k$();
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = fullTag_1(this, tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp;
        var newPrefix = tmp1_elvis_lhs == null ? this.prefix_1 : tmp1_elvis_lhs;
        return getProperStructureDecoder(this.$this_1, descriptor, newPrefix, this.map_1);
      }
      decodeSerializableValue_xpnpad_k$(deserializer) {
        if (deserializer instanceof AbstractPolymorphicSerializer()) {
          var tmp0_safe_receiver = this.get_currentTagOrNull_yhyzw_k$();
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = fullTag_1(this, tmp0_safe_receiver + '.type');
          }
          var tmp1_elvis_lhs = tmp;
          var typeKey = tmp1_elvis_lhs == null ? fullTag_1(this, 'type') : tmp1_elvis_lhs;
          var tmp2_elvis_lhs = this.map_1.get_wei43m_k$(typeKey);
          var tmp_0;
          if (tmp2_elvis_lhs == null) {
            throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Missing 'type' field for polymorphic deserialization at '" + typeKey + "'");
          } else {
            tmp_0 = tmp2_elvis_lhs;
          }
          var typeName = tmp_0;
          var actualDeserializer = findPolymorphicSerializer_0(deserializer, this, typeName);
          return actualDeserializer.deserialize_sy6x50_k$(this);
        }
        return deserializer.deserialize_sy6x50_k$(this);
      }
      decodeTaggedValue_b1rwxv_k$(tag) {
        var tmp0_elvis_lhs = this.map_1.get_wei43m_k$(fullTag_1(this, tag));
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Missing value for field '" + fullTag_1(this, tag) + "'");
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      decodeTaggedValue_by1p0u_k$(tag) {
        return this.decodeTaggedValue_b1rwxv_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedString_fe7ocx_k$(tag) {
        var tmp0_elvis_lhs = this.map_1.get_wei43m_k$(fullTag_1(this, tag));
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Missing value for field '" + fullTag_1(this, tag) + "'");
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      decodeTaggedString_45pp1e_k$(tag) {
        return this.decodeTaggedString_fe7ocx_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedBoolean_8s5b84_k$(tag) {
        return toBooleanStrict(this.decodeTaggedString_fe7ocx_k$(tag));
      }
      decodeTaggedBoolean_172rbv_k$(tag) {
        return this.decodeTaggedBoolean_8s5b84_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedByte_oje7fc_k$(tag) {
        return toByte(this.decodeTaggedString_fe7ocx_k$(tag));
      }
      decodeTaggedByte_y3phtl_k$(tag) {
        return this.decodeTaggedByte_oje7fc_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedShort_b0y92g_k$(tag) {
        return toShort(this.decodeTaggedString_fe7ocx_k$(tag));
      }
      decodeTaggedShort_dapzw9_k$(tag) {
        return this.decodeTaggedShort_b0y92g_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedChar_ha7850_k$(tag) {
        return single(this.decodeTaggedString_fe7ocx_k$(tag));
      }
      decodeTaggedChar_w7yrsn_k$(tag) {
        return this.decodeTaggedChar_ha7850_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedInt_9hzwhn_k$(tag) {
        return toInt(this.decodeTaggedString_fe7ocx_k$(tag));
      }
      decodeTaggedInt_mhypkc_k$(tag) {
        return this.decodeTaggedInt_9hzwhn_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedLong_uzg5b0_k$(tag) {
        return toLong(this.decodeTaggedString_fe7ocx_k$(tag));
      }
      decodeTaggedLong_y9rqqb_k$(tag) {
        return this.decodeTaggedLong_uzg5b0_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedFloat_hjyf60_k$(tag) {
        // Inline function 'kotlin.text.toFloat' call
        var this_0 = this.decodeTaggedString_fe7ocx_k$(tag);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return toDouble(this_0);
      }
      decodeTaggedFloat_81o7o9_k$(tag) {
        return this.decodeTaggedFloat_hjyf60_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedDouble_u6dgwh_k$(tag) {
        return toDouble(this.decodeTaggedString_fe7ocx_k$(tag));
      }
      decodeTaggedDouble_aa801q_k$(tag) {
        return this.decodeTaggedDouble_u6dgwh_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      decodeTaggedEnum_lbnta6_k$(tag, enumDescriptor) {
        var name = this.decodeTaggedString_fe7ocx_k$(tag);
        return enumDescriptor.getElementIndex_utfbym_k$(name);
      }
      decodeTaggedEnum_iouca9_k$(tag, enumDescriptor) {
        return this.decodeTaggedEnum_lbnta6_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
      }
      decodeTaggedNotNullMark_t788xf_k$(tag) {
        return hasKeyOrPrefix(this, tag);
      }
      decodeTaggedNotNullMark_opj0f8_k$(tag) {
        return this.decodeTaggedNotNullMark_t788xf_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ClassDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    ClassDecoderClass = $;
  }
  return ClassDecoderClass;
}
var ListDecoderClass;
function ListDecoder() {
  if (ListDecoderClass === VOID) {
    class $ extends SequentialDecoder() {
      constructor($outer, prefix, map, $box) {
        if ($box === VOID)
          $box = {};
        prefix = prefix === VOID ? '' : prefix;
        $box.$this_1 = $outer;
        super($box);
        this.prefix_1 = prefix;
        this.map_1 = map;
        this.serializersModule_1 = this.$this_1.serializersModule_1;
        this.currentIndex_1 = 0;
        var tmp = this;
        tmp.size$delegate_1 = lazy(() => {
          var tmp;
          if (this.map_1.get_wei43m_k$(this.prefix_1) === '~') {
            tmp = 0;
          } else {
            var count = 0;
            while (hasKeyOrPrefix_0(this, count)) {
              count = count + 1 | 0;
            }
            tmp = count;
          }
          return tmp;
        });
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        return this.currentIndex_1 < _get_size__ddoh9m(this) ? this.currentIndex_1 : -1;
      }
      decodeCollectionSize_l3mlkk_k$(descriptor) {
        return _get_size__ddoh9m(this);
      }
      decodeNextStringElement_7ufuay_k$() {
        var _unary__edvuaz = this.currentIndex_1;
        this.currentIndex_1 = _unary__edvuaz + 1 | 0;
        var full = fullTag_2(this, _unary__edvuaz);
        var tmp0_elvis_lhs = this.map_1.get_wei43m_k$(full);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Missing value for index '" + full + "'");
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      decodeNotNullMark_us4ba1_k$() {
        // Inline function 'kotlin.let' call
        var it = this.map_1.get_wei43m_k$(fullTag_2(this, this.currentIndex_1));
        return !(it == null) && !(it === 'NULL');
      }
      decodeSerializableElement_uahnnv_k$(descriptor, index, deserializer, previousValue) {
        var _unary__edvuaz = this.currentIndex_1;
        this.currentIndex_1 = _unary__edvuaz + 1 | 0;
        var newPrefix = fullTag_2(this, _unary__edvuaz);
        var tmp0 = this.map_1.get_keys_wop4xp_k$();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (startsWith(element, newPrefix + '.')) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        var hasNestedKeys = tmp$ret$0;
        return deserializer.deserialize_sy6x50_k$(hasNestedKeys || !this.map_1.containsKey_aw81wo_k$(newPrefix) ? getProperStructureDecoder(this.$this_1, deserializer.get_descriptor_wjt6a0_k$(), newPrefix, this.map_1) : new (UriDecoder())(this.$this_1, ensureNotNull(this.map_1.get_wei43m_k$(newPrefix))));
      }
      decodeNullableSerializableElement_k2y6ab_k$(descriptor, index, deserializer, previousValue) {
        var _unary__edvuaz = this.currentIndex_1;
        this.currentIndex_1 = _unary__edvuaz + 1 | 0;
        var newPrefix = fullTag_2(this, _unary__edvuaz);
        var value = this.map_1.get_wei43m_k$(newPrefix);
        if (value === 'NULL')
          return null;
        var tmp0 = this.map_1.get_keys_wop4xp_k$();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (startsWith(element, newPrefix + '.')) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        var hasNestedKeys = tmp$ret$0;
        if (!hasNestedKeys && value == null)
          return null;
        return deserializer.deserialize_sy6x50_k$(hasNestedKeys || value == null ? getProperStructureDecoder(this.$this_1, deserializer.get_descriptor_wjt6a0_k$(), newPrefix, this.map_1) : new (UriDecoder())(this.$this_1, value));
      }
    }
    initMetadataForClass($, 'ListDecoder');
    ListDecoderClass = $;
  }
  return ListDecoderClass;
}
var MapDecoderClass;
function MapDecoder() {
  if (MapDecoderClass === VOID) {
    class $ extends SequentialDecoder() {
      constructor($outer, prefix, map_0, $box) {
        if ($box === VOID)
          $box = {};
        prefix = prefix === VOID ? '' : prefix;
        $box.$this_1 = $outer;
        super($box);
        this.prefix_1 = prefix;
        this.map_1 = map_0;
        this.serializersModule_1 = this.$this_1.serializersModule_1;
        var tmp = this;
        tmp.keys$delegate_1 = lazy(() => {
          var tmp;
          if (this.map_1.get_wei43m_k$(this.prefix_1) === '~') {
            return emptyList();
          }
          var tmp_0;
          // Inline function 'kotlin.text.isEmpty' call
          var this_0 = this.prefix_1;
          if (charSequenceLength(this_0) === 0) {
            tmp_0 = '';
          } else {
            tmp_0 = this.prefix_1 + '.';
          }
          var prefixDot = tmp_0;
          // Inline function 'kotlin.let' call
          var seq = asSequence(this.map_1.get_keys_wop4xp_k$());
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          var this_1 = this.prefix_1;
          if (charSequenceLength(this_1) === 0) {
            tmp_1 = seq;
          } else {
            tmp_1 = filter(seq, (it) => startsWith(it, prefixDot));
          }
          var tmp_2 = tmp_1;
          return toList(distinct(map(tmp_2, (key) => {
            var tmp;
            // Inline function 'kotlin.text.isEmpty' call
            var this_0 = this.prefix_1;
            if (charSequenceLength(this_0) === 0) {
              tmp = substringBefore(key, _Char___init__impl__6a9atx(46));
            } else {
              tmp = substringBefore(removePrefix(key, prefixDot), _Char___init__impl__6a9atx(46));
            }
            return tmp;
          })));
        });
        this.currentIndex_1 = 0;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        return this.currentIndex_1 < imul(_get_keys__d97k5z(this).get_size_woubt6_k$(), 2) ? this.currentIndex_1 : -1;
      }
      decodeCollectionSize_l3mlkk_k$(descriptor) {
        return _get_keys__d97k5z(this).get_size_woubt6_k$();
      }
      decodeNextStringElement_7ufuay_k$() {
        var tmp;
        if ((this.currentIndex_1 % 2 | 0) === 0) {
          tmp = currentKey(this);
        } else {
          var key = currentKey(this);
          var tmp0_elvis_lhs = this.map_1.get_wei43m_k$(fullTag_3(this, key));
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("Missing value for key '" + key + "'");
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          tmp = tmp_0;
        }
        var result = tmp;
        this.currentIndex_1 = this.currentIndex_1 + 1 | 0;
        return result;
      }
      decodeNotNullMark_us4ba1_k$() {
        return this.map_1.containsKey_aw81wo_k$(currentKey(this));
      }
      decodeSerializableElement_uahnnv_k$(descriptor, index, deserializer, previousValue) {
        var tmp;
        if ((index % 2 | 0) === 0) {
          tmp = deserializer.deserialize_sy6x50_k$(new (UriDecoder())(this.$this_1, currentKey(this)));
        } else {
          var key = currentKey(this);
          var newPrefix = fullTag_3(this, key);
          var tmp0 = this.map_1.get_keys_wop4xp_k$();
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_0;
            if (isInterface(tmp0, Collection())) {
              tmp_0 = tmp0.isEmpty_y1axqb_k$();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (startsWith(element, newPrefix + '.')) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          var hasNestedKeys = tmp$ret$0;
          tmp = deserializer.deserialize_sy6x50_k$(hasNestedKeys || !this.map_1.containsKey_aw81wo_k$(newPrefix) ? getProperStructureDecoder(this.$this_1, deserializer.get_descriptor_wjt6a0_k$(), newPrefix, this.map_1) : new (UriDecoder())(this.$this_1, ensureNotNull(this.map_1.get_wei43m_k$(newPrefix))));
        }
        var result = tmp;
        this.currentIndex_1 = this.currentIndex_1 + 1 | 0;
        return result;
      }
      decodeNullableSerializableElement_k2y6ab_k$(descriptor, index, deserializer, previousValue) {
        if ((index % 2 | 0) === 0) {
          this.currentIndex_1 = this.currentIndex_1 + 1 | 0;
          return (new (UriDecoder())(this.$this_1, currentKey(this))).decodeSerializableValue_xpnpad_k$(deserializer);
        }
        var key = currentKey(this);
        var newPrefix = fullTag_3(this, key);
        var value = this.map_1.get_wei43m_k$(newPrefix);
        this.currentIndex_1 = this.currentIndex_1 + 1 | 0;
        if (value === 'NULL')
          return null;
        var tmp0 = this.map_1.get_keys_wop4xp_k$();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (startsWith(element, newPrefix + '.')) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        var hasNestedKeys = tmp$ret$0;
        if (!hasNestedKeys && value == null)
          return null;
        return deserializer.deserialize_sy6x50_k$(hasNestedKeys || value == null ? getProperStructureDecoder(this.$this_1, deserializer.get_descriptor_wjt6a0_k$(), newPrefix, this.map_1) : new (UriDecoder())(this.$this_1, value));
      }
      decodeSequentially_xlblqy_k$() {
        return true;
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
    }
    initMetadataForClass($, 'MapDecoder');
    MapDecoderClass = $;
  }
  return MapDecoderClass;
}
var ObjectDecoderClass;
function ObjectDecoder() {
  if (ObjectDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor($outer, prefix, map, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        super($box);
        this.prefix_1 = prefix;
        this.map_1 = map;
        this.serializersModule_1 = this.$this_1.serializersModule_1;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        return -1;
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
    }
    initMetadataForClass($, 'ObjectDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    ObjectDecoderClass = $;
  }
  return ObjectDecoderClass;
}
var SequentialDecoderClass;
function SequentialDecoder() {
  if (SequentialDecoderClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
      }
      decodeBoolean_m0aca_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode primitive directly');
      }
      decodeByte_jzz7je_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode primitive directly');
      }
      decodeChar_dcmcfa_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode primitive directly');
      }
      decodeDouble_ur8l0f_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode primitive directly');
      }
      decodeFloat_jcnrwu_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode primitive directly');
      }
      decodeInt_8iq8f5_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode primitive directly');
      }
      decodeLong_jzt186_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode primitive directly');
      }
      decodeShort_jjqk32_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode primitive directly');
      }
      decodeString_x3hxsx_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode primitive directly');
      }
      decodeEnum_slg6lu_k$(enumDescriptor) {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + ' cannot decode enum directly');
      }
      decodeInline_ux3vza_k$(descriptor) {
        return this;
      }
      decodeNull_jzrmuj_k$() {
        return null;
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      decodeBooleanElement_vuyhtj_k$(descriptor, index) {
        return toBooleanStrict(this.decodeNextStringElement_7ufuay_k$());
      }
      decodeByteElement_c1pisz_k$(descriptor, index) {
        return toByte(this.decodeNextStringElement_7ufuay_k$());
      }
      decodeShortElement_pzg12t_k$(descriptor, index) {
        return toShort(this.decodeNextStringElement_7ufuay_k$());
      }
      decodeCharElement_frbao3_k$(descriptor, index) {
        return single(this.decodeNextStringElement_7ufuay_k$());
      }
      decodeIntElement_941u6a_k$(descriptor, index) {
        return toInt(this.decodeNextStringElement_7ufuay_k$());
      }
      decodeLongElement_994anb_k$(descriptor, index) {
        return toLong(this.decodeNextStringElement_7ufuay_k$());
      }
      decodeFloatElement_p2q55h_k$(descriptor, index) {
        // Inline function 'kotlin.text.toFloat' call
        var this_0 = this.decodeNextStringElement_7ufuay_k$();
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return toDouble(this_0);
      }
      decodeDoubleElement_isei84_k$(descriptor, index) {
        return toDouble(this.decodeNextStringElement_7ufuay_k$());
      }
      decodeStringElement_3oenpg_k$(descriptor, index) {
        return this.decodeNextStringElement_7ufuay_k$();
      }
      decodeSequentially_xlblqy_k$() {
        return true;
      }
      decodeInlineElement_s8883o_k$(descriptor, index) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
    }
    protoOf($).decodeSerializableValue_xpnpad_k$ = decodeSerializableValue;
    protoOf($).decodeCollectionSize_l3mlkk_k$ = decodeCollectionSize;
    protoOf($).decodeSerializableElement$default_j0zaoi_k$ = decodeSerializableElement$default;
    initMetadataForClass($, 'SequentialDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    SequentialDecoderClass = $;
  }
  return SequentialDecoderClass;
}
function UriFormat$encodeToString$lambda(it) {
  return it.get_key_18j28a_k$() + '=' + it.get_value_j01efc_k$();
}
var UriFormatClass;
function UriFormat() {
  if (UriFormatClass === VOID) {
    class $ {
      constructor(serializersModule) {
        this.serializersModule_1 = serializersModule;
      }
      encodeToString_k0apqx_k$(serializer, value) {
        var e = new (UriEncoder())(this);
        e.encodeSerializableValue_3uuzip_k$(serializer, value);
        return e.getUri_kntv4a_k$();
      }
      decodeFromString_jwu9sq_k$(deserializer, string) {
        var d = new (UriDecoder())(this, string);
        return d.decodeSerializableValue_xpnpad_k$(deserializer);
      }
      encodeToString_hz9uyy_k$(map) {
        var tmp = map.get_entries_p20ztl_k$();
        return joinToString(tmp, '&', VOID, VOID, VOID, VOID, UriFormat$encodeToString$lambda);
      }
      encodeToStringMap_1jy59p_k$(serializer, key, value, dest) {
        if (isNonStructure(this, unwrap(this, serializer.get_descriptor_wjt6a0_k$()).get_kind_wop7ml_k$())) {
          // Inline function 'kotlin.collections.set' call
          var value_0 = this.encodeToString_k0apqx_k$(serializer, value);
          dest.put_4fpzoq_k$(key, value_0);
        } else {
          StringMapEncoder().new_com_lightningkite_kotlinx_serialization_uri_UriFormat_StringMapEncoder_sp8p1n_k$(this, key, dest).encodeSerializableValue_3uuzip_k$(serializer, value);
        }
      }
      decodeFromStringMap_zhdvns_k$(deserializer, key, source) {
        var tmp;
        if (isNonStructure(this, unwrap(this, deserializer.get_descriptor_wjt6a0_k$()).get_kind_wop7ml_k$())) {
          var tmp0_elvis_lhs = source.get_wei43m_k$(key);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Missing key ' + key);
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          tmp = this.decodeFromString_jwu9sq_k$(deserializer, tmp_0);
        } else {
          tmp = (new (StringMapDecoder())(this, source, key)).decodeSerializableValue_xpnpad_k$(deserializer);
        }
        return tmp;
      }
      mapContainsKey_70v9ke_k$(map, key) {
        var tmp0 = map.get_keys_wop4xp_k$();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (startsWith(element, key)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'UriFormat');
    UriFormatClass = $;
  }
  return UriFormatClass;
}
//region block: exports
export {
  UriFormat as UriFormat1t8mwnpxf0d72,
};
//endregion

//# sourceMappingURL=UriFormat.mjs.map
